<ng-template ngFor [ngForOf]="parts" let-part let-isOdd="odd"><span *ngIf="isOdd" class="{{highlightClass}}">{{part}}</span><ng-template [ngIf]="!isOdd">{{part}}</ng-template></ng-template>


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/@ng-bootstrap/ng-bootstrap/typeahead/highlight.d.ts.NgbHighlight.html